import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './Pages/App/App';
import reportWebVitals from './reportWebVitals';
import { PicoProvider } from './Context/PicoContext';
import { FilterProvider } from './Context/FilterContext';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import outputs from './amplify_outputs.json';
import { NavigationProvider } from './Context/NavigationContext';
import { generateKey, handleSessionExpired } from './Utils/functions';
import { Hub } from 'aws-amplify/utils';
Amplify.configure(outputs);

Hub.listen('auth', ({ payload }) => {
  if (payload.event === 'tokenRefresh_failure') {
    handleSessionExpired();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));

function Main() {
  // check if session exists
  const deviceId = localStorage.getItem('deviceId');
  if (!deviceId) {
    // save session in local storage
    const key = generateKey();
    localStorage.setItem('deviceId', key);
    localStorage.setItem('SearchRemaining', '1');
  }

  return (
    <React.StrictMode>
      <Authenticator.Provider>
        <NavigationProvider>
          <FilterProvider>
            <PicoProvider>
              <App />
              <footer className="footer">© 2026 MedRPT LLC</footer>
            </PicoProvider>
          </FilterProvider>
        </NavigationProvider>
      </Authenticator.Provider>
    </React.StrictMode>
  );
}
root.render(<Main />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
